"use strict";

var _Array$from = require("@babel/runtime-corejs2/core-js/array/from");

var _Symbol = require("@babel/runtime-corejs2/core-js/symbol");

var _Symbol$iterator = require("@babel/runtime-corejs2/core-js/symbol/iterator");

var _Array$isArray = require("@babel/runtime-corejs2/core-js/array/is-array");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = _request;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _deleteProperty = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/delete-property"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/typeof"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _pick2 = _interopRequireDefault(require("lodash/pick"));

var _isArray2 = _interopRequireDefault(require("lodash/isArray"));

var _defaults2 = _interopRequireDefault(require("lodash/defaults"));

var _qs = _interopRequireDefault(require("qs"));

var _xhr = _interopRequireDefault(require("../lib/xhr"));

var _detect = _interopRequireDefault(require("../lib/detect"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof _Symbol !== "undefined" && o[_Symbol$iterator] || o["@@iterator"]; if (!it) { if (_Array$isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * @name request
 * @param {Object} options
 * @returns {Promise}
 */
function _request(options) {
  return new _promise.default(function (resolve) {
    var params = (0, _pick2.default)(options, 'method', 'uri', 'withCredentials', 'headers', 'timeout', 'responseType'); // Set `response` to `true` to approximate an `HttpResponse` object

    params.response = true;
    setXhr(params);
    bindProgressEvents(params, options);
    setAuth(params, options);
    setCookies(params, options);
    setDefaults(params, options);
    setResponseType(params, options);
    setContentType(params, options);
    setPayload(params, options);
    setQs(params, options);
    options.logger.debug("start http ".concat(options.method ? options.method : 'request', " to ").concat(options.uri));
    var x = (0, _xhr.default)(params, function (error, response) {
      /* istanbul ignore next */
      if (error) {
        options.logger.warn(error);
      }
      /* istanbul ignore else */


      if (response) {
        if (response.statusCode >= 400) {
          options.logger.warn("http ".concat(options.method ? options.method : 'request', " to ").concat(options.uri, " result: ").concat(response.statusCode));
        } else {
          options.logger.debug("http ".concat(options.method ? options.method : 'request', " to ").concat(options.uri, " result: ").concat(response.statusCode));
        }

        response.options = options;
        processResponseJson(response, params);
        resolve(response);
      } else {
        resolve({
          statusCode: 0,
          options: options,
          headers: options.headers,
          method: options.method,
          url: options.uri,
          body: error
        });
      }
    });
    x.onprogress = options.download.emit.bind(options.download, 'progress');
  }).catch(function (error) {
    options.logger.warn(error);
    /* eslint arrow-body-style: [0] */

    /* istanbul ignore next */

    return {
      statusCode: 0,
      options: options,
      headers: options.headers,
      method: options.method,
      url: options.uri,
      body: error
    };
  });
  /**
   * @param {Object} params
   * @param {Object} o
   * @private
   * @returns {undefined}
   */

  function bindProgressEvents(params, o) {
    if (params.method && ['PATCH', 'POST', 'PUT'].includes(params.method.toUpperCase())) {
      if (!params.xhr) {
        params.xhr = new XMLHttpRequest();
      }

      params.xhr.upload.onprogress = o.upload.emit.bind(o.upload, 'progress');
    }
  }
  /**
   * @param {Object} params
   * @param {Object} o
   * @private
   * @returns {undefined}
   */


  function setXhr(params) {
    params.xhr = new XMLHttpRequest();
  }
  /**
   * @param {Object} params
   * @param {Object} o
   * @private
   * @returns {undefined}
   */


  function setAuth(params, o) {
    if (o.auth) {
      if (o.auth.bearer) {
        params.headers.authorization = "Bearer ".concat(o.auth.bearer);
      } else {
        var user = o.auth.user || o.auth.username;
        var pass = o.auth.pass || o.auth.password;
        var token = btoa("".concat(user, ":").concat(pass));
        params.headers.authorization = "Basic ".concat(token);
      }
    }
  }
  /**
   * @param {Object} params
   * @param {Object} o
   * @private
   * @returns {undefined}
   */


  function setCookies(params, o) {
    if (o.jar) {
      params.withCredentials = true;
    }
  }
  /**
   * @param {Object} params
   * @param {Object} o
   * @private
   * @returns {undefined}
   */


  function setDefaults(params, o) {
    var defs = {
      cors: true,
      // raynos/xhr defaults withCredentials to true if cors is true, so we need
      // to make it explicitly false by default
      withCredentials: false,
      timeout: 0
    };
    (0, _defaults2.default)(params, (0, _pick2.default)(o, (0, _keys.default)(defs)), defs);
  }
  /**
   * @param {Object} params
   * @param {Object} o
   * @private
   * @returns {undefined}
   */


  function setResponseType(params, o) {
    if (o.responseType === 'buffer') {
      params.responseType = 'arraybuffer';
    }
  }
  /**
   * @param {Object} params
   * @param {Object} o
   * @private
   * @returns {undefined}
   */


  function setContentType(_x, _x2) {
    return _setContentType.apply(this, arguments);
  }
  /**
   * @param {Object} params
   * @param {Object} o
   * @private
   * @returns {undefined}
   */


  function _setContentType() {
    _setContentType = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(params, o) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(o.body instanceof Blob || o.body instanceof ArrayBuffer)) {
                _context.next = 8;
                break;
              }

              o.json = params.json = false;
              _context.t0 = params.headers['content-type'];

              if (_context.t0) {
                _context.next = 7;
                break;
              }

              _context.next = 6;
              return (0, _detect.default)(o.body);

            case 6:
              _context.t0 = _context.sent;

            case 7:
              params.headers['content-type'] = _context.t0;

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _setContentType.apply(this, arguments);
  }

  function setQs(params, o) {
    if (o.qs) {
      params.uri += "?".concat(_qs.default.stringify(o.qs));
    }
  }
  /**
   * Converts arraybuffers to blobs before uploading them
   * @param {mixed} file
   * @private
   * @returns {mixed}
   */


  function ensureBlob(file) {
    if (file instanceof ArrayBuffer) {
      var ret = file.type ? new Blob([file], {
        type: file.type
      }) : new Blob([file]);
      ret.filename = file.filename || file.name || 'untitled';
      return ret;
    }

    return file;
  }
  /**
   * Appends an item to a form
   * @param {FormData} form
   * @param {string} key
   * @param {mixed} value
   * @returns {undefined}
   */


  function append(form, key, value) {
    if ((0, _isArray2.default)(value)) {
      var _iterator = _createForOfIteratorHelper(value),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var v = _step.value;
          append(form, key, v);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return;
    }

    value = ensureBlob(value);

    if (value.name) {
      value.filename = value.name;
      form.append(key, value, value.name);
    } else {
      form.append(key, value);
    }
  }
  /**
   * @param {Object} params
   * @param {Object} o
   * @private
   * @returns {undefined}
   */


  function setPayload(params, o) {
    if ((!('json' in o) || o.json === true) && o.body) {
      params.json = o.body;
    } else if (o.form) {
      params.headers['Content-Type'] = 'application/x-www-form-urlencoded';
      params.body = _qs.default.stringify(o.form);
      (0, _deleteProperty.default)(params, 'json');
    } else if (o.formData) {
      params.body = (0, _keys.default)(o.formData).reduce(function (fd, key) {
        var value = o.formData[key];
        append(fd, key, value);
        return fd;
      }, new FormData());
    } else {
      params.body = o.body;
      (0, _deleteProperty.default)(params, 'json');
    }
  }
  /**
   * @param {Object} response
   * @param {Object} params
   * @private
   * @returns {undefined}
   */


  function processResponseJson(response, params) {
    // If params.json is not defined, xhr won't deserialize the response
    // so we should give it a shot just in case.
    if (!params.json && (0, _typeof2.default)(response.body) !== 'object') {
      try {
        response.body = JSON.parse(response.body);
      } catch (e) {
        /* eslint no-empty: [0] */
      }
    }
  }
}
//# sourceMappingURL=request.shim.js.map
